import React, { useEffect, useState } from 'react';

// import { useParams } from 'react-router-dom';
import { addAttachmentToItem } from './ItemService';
import { getAllAttachments } from '../Attachments/AttachmentService';
// import listItemAttachments from './ItemAttachmentList';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';
// import appProgrammeList from './AppProgrammeList'
//import listItemChildren from './ItemChildrenList';

// const AttachChildren = ({ listItemChildren, parentId, sectionId }) => {
const AttachItemAttachment = ({ listItemAttachments, itemId }) => {
  const [open, setOpen] = useState(false);
  const [attachments, setAttachments] = useState<any[]>([]);
  //const navigate = useNavigate();

  // const [name, setName] = useState('');
  // const [description, setDescription] = useState('');
  // const [contactPerson, setContactPerson] = useState('');
  // const [location, setLocation] = useState('');
  // const [status, setStatus] = useState('');

  const [selectedAttachmentId, setSelectedAttachmentId] = useState(null);

  //const { itemid } = useParams();

  const handleChange = (attachmentId) => {
    setSelectedAttachmentId(attachmentId);
  };

  const handleClickOpen = () => {
    listItemAttachments();
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  useEffect(() => {
    listAttachments();
  }, [itemId]);

  function listAttachments() {
    getAllAttachments()
      .then((response) => {
        setAttachments(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  function attachSelectedAttachment(itemId, attachmentId) {
    //const attachment = {name};

    addAttachmentToItem(itemId, attachmentId)
      .then(() => {
        // appProgrammeList();
        listItemAttachments();
        handleClose(null, null);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  return (
    <div>
      <Button onClick={handleClickOpen}>Select Attachment</Button>
      <Dialog disableEscapeKeyDown open={open}>
        <DialogTitle>Select</DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              {/* <InputLabel htmlFor="demo-dialog-native">Name</InputLabel> */}
              <Select
                native
                value={selectedAttachmentId || ''} // Use selectedItemId as the value
                onChange={(e) => handleChange(e.target.value)}
                input={
                  <OutlinedInput
                    label="Select Attachment"
                    id="demo-dialog-native"
                  />
                }
              >
                {/* Ensure "Select Item" option is selected by default */}
                <option value={''} disabled>
                  Select Item
                </option>
                {/* Map over items to generate options */}
                {attachments.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={addProgrammeAssignment(progid, selectedProgrammeId)}>Add</Button> */}
          <Button onClick={() => handleClose(null, null)}>Cancel</Button>
          <Button
            onClick={() =>
              attachSelectedAttachment(itemId, selectedAttachmentId)
            }
          >
            Select
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AttachItemAttachment;
